export const WHATSAPP_FLOW_VERTICAL_OPTIONS = [
  { value: 'Sales', label: 'Sales' },
  { value: 'Accounts', label: 'Accounts' },
  { value: 'Operations', label: 'Operations' },
  { value: 'Management', label: 'Management' },
  { value: 'Marketing', label: 'Marketing' }
];

export function resolveTemplateApprovalStatus(flow) {
  return String(
    flow?.template_approval_status ?? flow?.template_status ?? flow?.approval_status ?? ''
  ).toUpperCase();
}

export function templateApprovalStatusBadgeClass(status) {
  const s = String(status || '').toUpperCase();
  if (s === 'PENDING' || s === 'IN_REVIEW') return 'bg-amber-50 text-amber-800 border-amber-200';
  if (s === 'APPROVED' || s === 'ACTIVE')
    return 'bg-emerald-50 text-emerald-800 border-emerald-200';
  if (s === 'REJECTED' || s === 'DISABLED') return 'bg-rose-50 text-rose-800 border-rose-200';
  return 'bg-gray-50 text-gray-700 border-gray-200';
}

export function isFlowApprovedForWebhook(flow) {
  const status = resolveTemplateApprovalStatus(flow);
  return status === 'APPROVED' || status === 'ACTIVE';
}

export function isFlowActive(flow) {
  return flow?.is_active === true;
}

export function isFlowSalesVertical(flow) {
  return String(flow?.vertical ?? '').trim().toUpperCase() === 'SALES';
}

export function isFlowAccountsVertical(flow) {
  return String(flow?.vertical ?? '').trim().toUpperCase() === 'ACCOUNTS';
}

export function isFlowSelectableForPreleadAutoStart(flow) {
  return isFlowActive(flow) && isFlowApprovedForWebhook(flow) && isFlowSalesVertical(flow);
}

export function isFlowSelectableForInvoiceNotification(flow) {
  return isFlowActive(flow) && isFlowApprovedForWebhook(flow) && isFlowAccountsVertical(flow);
}

export function isFlowSelectableForPaymentNotification(flow) {
  return isFlowSelectableForInvoiceNotification(flow);
}
